module.exports = __webpack_public_path__ + "static/media/releaseOfParentNew.7650fa31.png";